import { updateVision as _updateVision } from '@griply/services';
import { doc, serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { UpdateVision } from 'shared/types/vision';

import { getDatabase } from './helpers';

export const updateVision = async (vision: UpdateVision): Promise<void> => {
  await _updateVision({
    vision,
    doc,
    updateDoc,
    db: getDatabase(),
    timestampFromDate: (date: Date) => Timestamp.fromDate(date),
    serverTimestamp,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateVision,
        error,
        docPath: `visions/${vision.id}`,
      }),
  });
};
